import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["closeFlashBtn", "submitButton"]
  static values = { timeout: { type: Number, default: 3000 } }

  closeFlashBtnTargetConnected() {
    if (this.hasCloseFlashBtnTarget && document.querySelector('#newReferralFormSubmitButton')) {
      document.querySelector('#newReferralFormSubmitButton').disabled = false;
    }

    setTimeout(() => {
      if(this.hasCloseFlashBtnTarget) {
        // Remove alert elements entirely so iOS doesn't retain background color in status bar
        this.element.querySelectorAll('.alert').forEach(el => el.remove());
      }
    }, this.timeoutValue)
  }
}
